import { render, staticRenderFns } from "./positionManage.vue?vue&type=template&id=e05f19f6&scoped=true"
import script from "./positionManage.vue?vue&type=script&lang=js"
export * from "./positionManage.vue?vue&type=script&lang=js"
import style0 from "./positionManage.vue?vue&type=style&index=0&id=e05f19f6&lang=scss&scoped=true"
import style1 from "./positionManage.vue?vue&type=style&index=1&id=e05f19f6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e05f19f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e05f19f6')) {
      api.createRecord('e05f19f6', component.options)
    } else {
      api.reload('e05f19f6', component.options)
    }
    module.hot.accept("./positionManage.vue?vue&type=template&id=e05f19f6&scoped=true", function () {
      api.rerender('e05f19f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/positionManage/positionManage.vue"
export default component.exports